module.exports = __webpack_public_path__ + "AdobeStock_601258960_cropped.jpg?06035f42dbb06c6936e9572e5f377810";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/AdobeStock_601258960_cropped.jpg
// module id = 51
// module chunks = 0